import axios from 'axios'
import compress from 'graphql-query-compress' // TODO: remove once all queries are generated with jsonToGraphQLQuery
import { HTTP_STATUS } from 'lib/core/resources/constants'
import { getHeaders } from './utils'
import { makeApolloClient } from './makeApolloClient'

axios.defaults.validateStatus = status => (status < HTTP_STATUS.INTERNAL_SERVER_ERROR)
axios.defaults.baseURL = `${process.env.REACT_APP_MAGENTO_URI}/rest`

/**
 * Send graphql queries using Apollo client
 */
export const apolloClient = makeApolloClient()

/**
 * Send a graphql query through Axios using GET
 */
export const axiosClient = async (graphqlQuery: string, v2: boolean = false) => {
  const minifiedQuery = compress(graphqlQuery).replace(/\+/g, '%2B')
  const url = v2 ? `?query={${minifiedQuery}}` : `?query=${minifiedQuery}`
  return axios.get(url, {
    baseURL: `${process.env.REACT_APP_MAGENTO_URI}/graphql`,
    headers: getHeaders()
  })
}
